import type { ZhuozhuoEntry } from '../../types';

export const data1: ZhuozhuoEntry[] = [
    {
        type: '竞速赛道',
        uid: '114460799',
        name: '捡起肥皂硬又黑',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['希诺宁', 4, '息燧之笛', 5],
            ['茜特菈莉', 6, '祭星者之望', 1],
            ['闲云', 2, '鹤鸣余音', 1],
        ],
        time: 81,
        cost: 17,
        video: 'https://www.bilibili.com/video/BV13otcz3Ewi/',
    },
    {
        type: '竞速赛道',
        uid: '515292393',
        name: '烟绯三月夏扬州',
        team: [
            ['烟绯', 6, '金流监督', 5],
            ['芙宁娜', 6, '静水流涌之辉', 4],
            ['茜特菈莉', 6, '祭星者之望', 2],
            ['伊涅芙', 0, '支离轮光', 1],
        ],
        time: 63,
        cost: 27,
        video: 'https://www.bilibili.com/video/BV1BrtWzSE3B/',
    },
    {
        type: '低成本赛道',
        uid: '114460799',
        name: '捡起肥皂硬又黑',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['火女主', 6, '狼牙', 5],
            ['茜特菈莉', 6, '祭礼残章', 5],
            ['闲云', 2, '证誓之明瞳', 5],
        ],
        time: 97,
        cost: 10,
        video: 'https://www.bilibili.com/video/BV13otcz3Ewi/',
    },
    {
        type: '无限制赛道',
        uid: '515292393',
        name: '烟绯三月夏扬州',
        team: [
            ['烟绯', 6, '金流监督', 5],
            ['芙宁娜', 6, '静水流涌之辉', 4],
            ['茜特菈莉', 6, '祭星者之望', 2],
            ['希诺宁', 4, '岩峰巡歌', 1],
        ],
        time: 79,
        cost: 31,
        video: 'https://www.bilibili.com/video/BV1VdYiz4EYF/',
    },
    {
        type: '无限制赛道',
        uid: '114460799',
        name: '捡起肥皂硬又黑',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['芙宁娜', 6, '静水流涌之辉', 1],
            ['茜特菈莉', 6, '祭星者之望', 2],
            ['希诺宁', 4, '岩峰巡歌', 1],
        ],
        time: 69,
        cost: 24,
        video: 'https://www.bilibili.com/video/BV1fqYCzQEYL/',
    },
    {
        type: '12 成本赛道',
        uid: '526041479',
        name: 'AronKing',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['芙宁娜', 2, '西风剑', 5],
            ['久岐忍', 2, '西福斯的月光', 3],
            ['班尼特', 6, '天空之刃', 1],
        ],
        time: 242,
        cost: 7.5,
        video: 'https://www.bilibili.com/video/BV12aYbzfEdq/',
    },
    {
        type: '12 成本赛道',
        uid: '526041479',
        name: 'AronKing',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['芙宁娜', 2, '西风剑', 5],
            ['久岐忍', 2, '西风剑', 1],
            ['班尼特', 6, '天空之刃', 1],
        ],
        time: 237,
        cost: 7,
        video: 'https://www.bilibili.com/video/BV15qewzvEG7/',
    },
    {
        type: '12 成本赛道',
        uid: '117979290',
        name: '倒立享受人参',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['茜特菈莉', 6, '讨龙英杰谭', 5],
            ['夜兰', 1, '绝弦', 5],
            ['行秋', 6, '祭礼剑', 5],
        ],
        time: 165,
        cost: 12,
        video: 'https://www.bilibili.com/video/BV1ZsYUzKErb/',
    },
    {
        type: '6 成本赛道',
        uid: '117979290',
        name: '倒立享受人参',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['班尼特', 6, '苍古自由之誓', 1],
            ['北斗', 6, '拾慧铸熔', 5],
            ['行秋', 6, '祭礼剑', 5],
        ],
        time: 316,
        cost: 4,
        video: 'https://www.bilibili.com/video/BV1dPYozQEvt/',
    },
    {
        type: '6 成本赛道',
        uid: '233258757',
        name: '穿越stars',
        team: [
            ['烟绯', 6, '溢彩心念', 1],
            ['班尼特', 6, '原木刀', 1],
            ['菲谢尔', 6, '落霞', 5],
            ['芙宁娜', 2, '有乐御簾切', 1],
        ],
        time: 241,
        cost: 6,
        video: 'https://www.bilibili.com/video/BV11MenzTEdn/'
    },
    {
        type: '12 成本赛道',
        uid: '241450391',
        name: '007号厨师长_',
        team: [
            ['烟绯', 6, '千叶浮梦', 5],
            ['久岐忍', 1, '东花坊时雨', 5],
            ['闲云', 2, '鹤鸣余音', 2],
            ['珊瑚宫心海', 0, '祭礼残章', 5],
        ],
        time: 217,
        cost: 12,
        video: 'https://www.bilibili.com/video/BV1j9e2zaEAA/'
    },
    {
        type: '6 成本赛道',
        uid: '191431882',
        name: 'TRUST_落星',
        team: [
            ['烟绯', 6, '金流监督', 1],
            ['芙宁娜', 2, '西风剑', 5],
            ['久岐忍', 6, '西风剑', 5],
            ['班尼特', 6, '原木刀', 5],
        ],
        time: 245,
        cost: 6,
        video: 'https://www.bilibili.com/video/BV1rqhyz9EuV/'
    },
    {
        type: '12 成本赛道',
        uid: '221400104',
        name: 'MatFaint',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['芙宁娜', 6, '西风剑', 4],
            ['茜特菈莉', 6, '祭礼残章', 5],
            ['希诺宁', 0, '试作斩岩', 1],
        ],
        time: 169,
        cost: 12,
        video: 'https://www.bilibili.com/video/BV15ShdzLECo/'
    },
    {
        type: '12 成本赛道',
        uid: '137610643',
        name: '三泠Mirei',
        team: [
            ['烟绯', 6, '万世流涌大典', 1],
            ['芙宁娜', 2, '西风剑', 5],
            ['希诺宁', 2, '岩峰巡歌', 1],
            ['伊涅芙', 0, '香韵奏者', 1],
        ],
        time: 164,
        cost: 12,
        video: 'https://www.bilibili.com/video/BV1gHH1zHEQb/'
    },
];

export const data2: ZhuozhuoEntry[] = [
    {
        type: '无限制赛道',
        uid: '515292393',
        name: '烟绯三月夏扬州',
        team: [
            ['烟绯', 6, '金流监督', 5],
            ['芙宁娜', 6, '静水流涌之辉', 5],
            ['茜特菈莉', 6, '祭星者之望', 2],
            ['希诺宁', 4, '岩峰巡歌', 1],
        ],
        time: 66,
        cost: 32,
        video: 'https://www.bilibili.com/video/BV1wekNB9Ewv/',
    },
    {
        type: '2金赛道',
        uid: '316581364',
        name: '不要起怪名字',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['杜林', 0, '黑蚀', 1],
            ['菲谢尔', 6, '绝弦', 5],
            ['夏沃蕾', 6, '沙中伟贤的对答', 5],
        ],
        time: 228,
        cost: 2,
        video: 'https://www.bilibili.com/video/BV18DkABPExh/',
    },
    {
        type: '6金赛道',
        uid: '255201020',
        name: '夜夕呀',
        team: [
            ['烟绯', 6, '金流监督', 1],
            ['芙宁娜', 1, '西风剑', 5],
            ['夜兰', 0, '西风猎弓', 5],
            ['班尼特', 6, '天空之刃', 1],
        ],
        time: 260,
        cost: 5,
        video: 'https://www.bilibili.com/video/BV1fdkPBUE1M/',
    },
    {
        type: '2金赛道',
        uid: '214075635',
        name: '始終如E',
        team: [
            ['烟绯', 6, '金流监督', 1],
            ['杜林', 0, '海渊终曲', 2],
            ['菲谢尔', 6, '绝弦', 5],
            ['夏沃蕾', 6, '黑缨枪', 5],
        ],
        time: 73 + 105 + 100,
        cost: 2,
        video: 'https://www.bilibili.com/video/BV1FokKBoE5C/',
    },
    {
        type: '12金赛道',
        uid: '189011363',
        name: '赫萝的末路',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['芙宁娜', 6, '圣显之钥', 1],
            ['枫原万叶', 2, '苍古自由之誓', 1],
            ['班尼特', 6, '西风剑', 5],
        ],
        time: 45 + 83 + 57,
        cost: 12,
        video: 'https://www.bilibili.com/video/BV14kkKBTEbV/',
    },
    {
        type: '12金赛道',
        uid: '189011363',
        name: '赫萝的末路',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['班尼特', 6, '西风剑', 5],
            ['枫原万叶', 2, '苍古自由之誓', 1],
            ['芙宁娜', 6, '圣显之钥', 1],
        ],
        time: 45+57+43,
        cost: 12,
        video: 'https://www.bilibili.com/video/BV11HrkBYELT/',
    },
    {
        type: '6金赛道',
        uid: '287394123',
        name: '是绯不是非啦',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['班尼特', 6, '原木刀', 4],
            ['芙宁娜', 2, '西风剑', 5],
            ['希诺宁', 2, '息燧之笛', 3],
        ],
        time: 73+109+84,
        cost: 6,
        video: 'https://www.bilibili.com/video/BV1f3rrBnE9x/',
    },
    {
        type: '12金赛道',
        uid: '216586765',
        name: '风纪委员赛赛娘',
        team: [
            ['烟绯', 6, '金流监督', 3],
            ['茜特菈莉', 2, '祭礼残章', 5],
            ['芙宁娜', 2, '灰河渡手', 5],
            ['希诺宁', 0, '息燧之笛', 3],
        ],
        time: 60 + 95 + 79,
        cost: 10,
        video: 'https://www.bilibili.com/video/BV1AKrrBREmR/',
    },
    {
        type: '12金赛道',
        uid: '????',
        name: 'MatFaint',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['茜特菈莉', 2, '祭礼残章', 5],
            ['芙宁娜', 6, '静水流涌之辉', 1],
            ['希诺宁', 0, '西风剑', 4],
        ],
        time: 123,
        cost: 12,
        video: 'https://www.bilibili.com/video/BV1KrrCBzEXy/',
    },
    {
        type: '6金赛道',
        uid: '201376275',
        name: 'NiconicoNikako',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['茜特菈莉', 2, '西风秘典', 5],
            ['爱可菲', 0, '香韵奏者', 1],
            ['班尼特', 6, '暗巷闪光', 4],
        ],
        time: 162,
        cost: 5,
        video: 'https://www.bilibili.com/video/BV1dPryBXEX9/',
    },
    {
        type: '6金赛道',
        uid: '204983597',
        name: '炸个二极管',
        team: [
            ['烟绯', 6, '万世流涌大典', 1],
            ['班尼特', 6, '西风剑', 5],
            ['芙宁娜', 3, '西风剑', 5],
            ['夜兰', 0, '西风猎弓', 5],
        ],
        time: 194,
        cost: 6,
        video: 'https://www.bilibili.com/video/BV1JErCBsEvb/',
    },
    {
        type: '12金赛道',
        uid: '189011363',
        name: '赫萝的末路',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['班尼特', 6, '西风剑', 5],
            ['枫原万叶', 2, '苍古自由之誓', 1],
            ['芙宁娜', 6, '圣显之钥', 1],
        ],
        time: 38+51+33,
        cost: 12,
        video: 'https://www.bilibili.com/video/BV11YrUBJEaN/',
    },
    {
        type: '无限制赛道',
        uid: '114460799',
        name: '捡起肥皂硬又黑',
        team: [
            ['烟绯', 6, '溢彩心念', 5],
            ['玛薇卡', 2, '焚曜千阳', 1],
            ['茜特菈莉', 6, '祭星者之望', 1],
            ['闲云', 2, '鹤鸣余音', 1],
        ],
        time: 42,
        cost: 21,
        video: 'https://www.bilibili.com/video/BV1zTrUBTEfo/',
    },
    {
        type: '6金赛道',
        uid: '218202105',
        name: '陆筱离',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['班尼特', 6, '试作斩岩', 1],
            ['芙宁娜', 2, '圣显之钥', 1],
            ['行秋', 6, '祭礼剑', 5],
        ],
        time: 52+77+74,
        cost: 4,
        video: 'https://www.bilibili.com/video/BV1K5rSBHEDj/',
    },
    {
        type: '6金赛道',
        uid: '257269802',
        name: 'FireArmor-Lava',
        team: [
            ['烟绯', 6, '金流监督', 1],
            ['班尼特', 6, '天空之刃', 1],
            ['芙宁娜', 2, '灰河渡手', 5],
            ['行秋', 6, '西风剑', 5],
        ],
        time: 67+112+71,
        cost: 5,
        video: 'https://www.bilibili.com/video/BV1DXrQBAEHC/',
    },
    {
        type: '6金赛道',
        uid: '195521889',
        name: 'pkzi',
        team: [
            ['烟绯', 6, '四风原典', 1],
            ['杜林', 2, '黑蚀', 1],
            ['菲谢尔', 6, '冬极白星', 1],
            ['夏沃蕾', 6, '沙中伟贤的对答', 5],
        ],
        time: 38+53+43,
        cost: 6,
        video: 'https://www.bilibili.com/video/BV1DXrQBAEtW/',
    },
    {
        type: '12金赛道',
        uid: '114460799',
        name: '捡起肥皂硬又黑',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['班尼特', 6, '原木刀', 1],
            ['茜特菈莉', 6, '祭星者之望', 1],
            ['闲云', 2, '鹤鸣余音', 1],
        ],
        time: 56,
        cost: 12,
        video: 'https://www.bilibili.com/video/BV1PprQB9ELq/',
    },
    {
        type: '2金赛道',
        uid: '255201020',
        name: '夜夕呀',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['班尼特', 6, '原木刀', 1],
            ['芙宁娜', 1, '西风剑', 3],
            ['行秋', 6, '西风剑', 5],
        ],
        time: 55+80+65,
        cost: 2,
        video: 'https://www.bilibili.com/video/BV1qRkpBAEpE/',
    },
    {
        type: '6金赛道',
        uid: '233258757',
        name: '穿越stars',
        team: [
            ['烟绯', 6, '真语秘匣', 1],
            ['班尼特', 6, '原木刀', 1],
            ['芙宁娜', 2, '静水流涌之辉', 1],
            ['行秋', 6, '祭礼剑', 5],
        ],
        time: 162,
        cost: 5,
        video: 'https://www.bilibili.com/video/BV1LPktBkEcF/',
    },
    {
        type: '2金赛道',
        uid: '???',
        name: 'AronKing',
        team: [
            ['烟绯', 1, '流浪乐章', 5],
            ['杜林', 1, '匣里龙吟', 5],
            ['菲谢尔', 6, '绝弦', 5],
            ['夏沃蕾', 6, '西风长枪', 3],
        ],
        time: 80+120+99,
        cost: 2,
        video: 'https://www.bilibili.com/video/BV1dHk4B3E5p/',
    },
    {
        type: '6金赛道',
        uid: '204983597',
        name: '炸个二极管',
        team: [
            ['烟绯', 6, '万世流涌大典', 1],
            ['班尼特', 6, '暗巷闪光', 3],
            ['芙宁娜', 3, '圣显之钥', 1],
            ['行秋', 6, '祭礼剑', 5],
        ],
        time: 43+61+47,
        cost: 6,
        video: 'https://www.bilibili.com/video/BV1fJkbBnEEt/',
    },
    {
        type: '6金赛道',
        uid: '233258757',
        name: '穿越stars',
        team: [
            ['烟绯', 6, '真语秘匣', 1],
            ['班尼特', 6, '原木刀', 1],
            ['芙宁娜', 2, '静水流涌之辉', 1],
            ['行秋', 6, '祭礼剑', 5],
        ],
        time: 147,
        cost: 5,
        video: 'https://www.bilibili.com/video/BV173keBwEu1/',
    },
    {
        type: '2金赛道',
        uid: '278276329',
        name: 'AAA秤砣批发',
        team: [
            ['烟绯', 6, '四风原典', 1],
            ['班尼特', 6, '原木刀', 1],
            ['菲谢尔', 6, '黎明破晓之史', 1],
            ['夏沃蕾', 6, '沙中伟贤的对答', 5],
        ],
        time: 223,
        cost: 2,
        video: 'https://www.bilibili.com/video/BV1bGk5BfEay/',
    },
    {
        type: '6金赛道',
        uid: '199815721',
        name: 'qwerasddfzx',
        team: [
            ['烟绯', 6, '四风原典', 1],
            ['班尼特', 6, '天空之刃', 1],
            ['芙宁娜', 2, '西风剑', 5],
            ['希诺宁', 0, '西风剑', 4],
        ],
        time: 72+104+100,
        cost: 6,
        video: 'https://www.bilibili.com/video/BV1K5z5BmEs6/',
    },
    {
        type: '6金赛道',
        uid: '201376275',
        name: 'NiconicoNikako',
        team: [
            ['烟绯', 6, '真语秘匣', 1],
            ['爱可菲', 0, '香韵奏者', 1],
            ['班尼特', 6, '暗巷闪光', 4],
            ['茜特菈莉', 2, '西风秘典', 5],
        ],
        time: 129,
        cost: 6,
        video: 'https://www.bilibili.com/video/BV1osBfB9EFk/',
    },
    {
        type: '2金赛道',
        uid: '100993787',
        name: '反向之箭高德伟',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['班尼特', 6, '原木刀', 5],
            ['菲谢尔', 6, '绝弦', 5],
            ['夏沃蕾', 6, '西风长枪', 5],
        ],
        time: 196,
        cost: 0,
        video: 'https://www.bilibili.com/video/BV1nXzKBUEwx/',
    },
    {
        type: '无限制赛道',
        uid: '100024195',
        name: 'Chris1096',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['班尼特', 6, '西风剑', 5],
            ['神里绫华', 6, '雾切之回光', 5],
            ['茜特菈莉', 2, '祭礼残章', 5],
        ],
        time: 197,
        cost: 14,
        video: 'https://www.bilibili.com/video/BV1BKzwBeErx/',
    },
    {
        type: '6金赛道',
        uid: '195521889',
        name: 'pkzi',
        team: [
            ['烟绯', 6, '四风原典', 1],
            ['杜林', 2, '黑蚀', 1],
            ['菲谢尔', 6, '冬极白星', 1],
            ['夏沃蕾', 6, '西风长枪', 5],
        ],
        time: 113,
        cost: 6,
        video: 'https://www.bilibili.com/video/BV1T7zzBQEgT/',
    },
    {
        type: '6金赛道',
        uid: '287394123',
        name: '是绯不是非啦',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['班尼特', 2, '原木刀', 4],
            ['芙宁娜', 2, '西风剑', 5],
            ['希诺宁', 6, '息燧之笛', 3],
        ],
        time: 236,
        cost: 6,
        video: 'https://www.bilibili.com/video/BV1wezCB4E7A/',
    },
    {
        type: '无限制赛道',
        uid: '???',
        name: '倒立享受人参',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['杜林', 6, '磐岩结绿', 1],
            ['芙宁娜', 6, '圣显之钥', 1],
            ['茜特菈莉', 6, '祭星者之望', 1],
        ],
        time: 55,
        cost: 24,
        video: 'https://www.bilibili.com/video/BV15tzkBkENV/',
    },
    {
        type: '2金赛道',
        uid: '???',
        name: 'AronKing',
        team: [
            ['烟绯', 1, '流浪乐章', 5],
            ['杜林', 1, '匣里龙吟', 5],
            ['菲谢尔', 1, '绝弦', 5],
            ['夏沃蕾', 6, '西风长枪', 3],
        ],
        time: 67+99+91,
        cost: 2,
        video: 'https://www.bilibili.com/video/BV1HHzxBrEtT/',
    },
    {
        type: '6金赛道',
        uid: '313888661',
        name: '宝马儿918',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['班尼特', 6, '西风剑', 5],
            ['芙宁娜', 2, '狼牙', 2],
            ['茜特菈莉', 2, '祭礼残章', 5],
        ],
        time: 166,
        cost: 6,
        video: 'https://www.bilibili.com/video/BV1Rr6FBdESQ/',
    },
    {
        type: '12金赛道',
        uid: '313888661',
        name: '宝马儿918',
        team: [
            ['烟绯', 6, '万世流涌大典', 1],
            ['班尼特', 6, '西风剑', 5],
            ['芙宁娜', 2, '狼牙', 2],
            ['茜特菈莉', 2, '祭礼残章', 5],
        ],
        time: 173,
        cost: 6,
        video: 'https://www.bilibili.com/video/BV1S36FBjEzp/',
    },
    {
        type: '6金赛道',
        uid: '526041479',
        name: 'AronKing',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['班尼特', 6, '天空之刃', 1],
            ['芙宁娜', 2, '西风剑', 5],
            ['哥伦比娅', 0, '讨龙英杰谭', 5],
        ],
        time: 42+91+58,
        cost: 5,
        video: 'https://www.bilibili.com/video/BV1a56KBBE46/',
    },
    {
        type: '2金赛道',
        uid: '100993787',
        name: '反向之箭高德伟',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['班尼特', 6, '原木刀', 5],
            ['菲谢尔', 6, '绝弦', 5],
            ['夏沃蕾', 6, '西风长枪', 5],
        ],
        time: 186,
        cost: 0,
        video: 'https://www.bilibili.com/video/BV1yHFdz1EWh/',
    },
    {
        type: '12金赛道',
        uid: '117979290',
        name: '倒立享受人参',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['班尼特', 6, '暗巷闪光', 2],
            ['茜特菈莉', 6, '讨龙英杰谭', 5],
            ['闲云', 2, '鹤鸣余音', 2],
        ],
        time: 82,
        cost: 12,
        video: 'https://www.bilibili.com/video/BV1CVcxzYEz2/',
    },
    {
        type: '2金赛道',
        uid: '164660165',
        name: '国语对白回归',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['杜林', 0, '狼牙', 5],
            ['菲谢尔', 6, '终末嗟叹之诗', 1],
            ['夏沃蕾', 6, '西风长枪', 5],
        ],
        time: 220,
        cost: 2,
        video: 'https://www.bilibili.com/video/BV1YmrkB1Eiu/',
    },
    {
        type: '6金赛道',
        uid: '209252938',
        name: '烟-法兽灼眼',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['班尼特', 6, '原木刀', 1],
            ['芙宁娜', 2, '西风剑', 2],
            ['行秋', 6, '祭礼剑', 5],
        ],
        time: 173,
        cost: 3,
        video: 'https://www.bilibili.com/video/BV1nvkjBQEhf/',
    },
    {
        type: '2金赛道',
        uid: '299880897',
        name: '粥还是盖饭',
        team: [
            ['烟绯', 6, '流浪乐章', 5],
            ['班尼特', 6, '原木刀', 3],
            ['行秋', 6, '祭礼剑', 5],
            ['伊涅芙', 0, '支离轮光', 1],
        ],
        time: 177,
        cost: 2,
        video: 'https://www.bilibili.com/video/BV1Pkcbz3ETt/',
    },
];
